define('ctaUtil',[
  'jquery',
  'storageUtil',

  // side effect includes
  'bat'
], function (
  $,
  storageUtil
) {
  $(window).on('loaded', function (e) {
    // TODO: is this still needed? can it be used on SET only?
    if (storageUtil.getZip() != null) {
      window.bat.updateSETLinks();
    }
  });
});

